import { FetchProvider } from '@motorway/motorway-handshake-components';

import { useDriver } from '../../contexts/Driver';

export const FetchWrapperComponent: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { driver } = useDriver();
  const { enquiryId = null, token = null } = driver ?? {};

  return (
    <FetchProvider {...{ enquiryId, token }}>
      {children}
    </FetchProvider>
  );
};
